import React, { memo } from 'react'
import tw from 'twin.macro'
import { DataRow } from 'src/components/shared/DataRow'
import type { PartnerDriverDetails } from 'src/interfaces/partnerDriver'

// A dash for a value not on file — cosmetic, not fabricated data.
const MISSING_VALUE = '—'

interface Props {
  driver: PartnerDriverDetails
}

/** Who a deletion removes — shown on the Delete contractor card and again in its confirmation. */
const ContractorDeletionSummaryComponent = ({ driver }: Props) => {
  const partnerName = driver.partner?.displayName || driver.partner?.name || MISSING_VALUE

  return (
    <div data-testid="partner-driver-deletion-summary">
      <DataRow title="ID" text={driver.id} textClassName={tw`font-mono`} />
      <DataRow title="External ID" text={driver.externalId || MISSING_VALUE} />
      <DataRow title="First name" text={driver.firstName || MISSING_VALUE} />
      <DataRow title="Last name" text={driver.lastName || MISSING_VALUE} />
      <DataRow title="Email" text={driver.email || MISSING_VALUE} />
      <DataRow title="Phone" text={driver.phone || MISSING_VALUE} />
      <DataRow title="Partner" text={partnerName} />
    </div>
  )
}

export const ContractorDeletionSummary = memo(ContractorDeletionSummaryComponent)
